import {useQuery} from "@tanstack/react-query";
import getBanners from "../services/banners/getBanners.service";

const useGetBannerList = () => {
  const {data, isError, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["homeBanners"],
    queryFn: getBanners,
    staleTime: 30 * 60 * 1000, // 30 minutes — banners rarely change
    refetchOnWindowFocus: false,
  });

  return {
    data: data?.data?.data,
    isError,
    isLoading,
    isSuccess,
    refetch,
    error,
  };
};

export default useGetBannerList;
